module.exports = __webpack_public_path__ + "static/images/styles/images/challenges/icon-shooting.0ec1c65f.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/challenges/icon-shooting.png
// module id = 3614
// module chunks = 11